// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_9c-4";
export var collapsed = "_9c-1";
export var headerBar = "_9c-0";
export var leftHeaderContent = "_9c-3";
export var subjectContainer = "_9c-2";